<template>
  <div class="comp-invoices">
    <h1 class="headline">INVOICES</h1>

    <div class="toolbar">
      <div class="btns">
        <button type="button" class="btn btn-outline-black w180" @click="showModalAdd = true">+ New Invoice</button>
      </div>

      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" placeholder="SEARCH INVOICES..." v-model="keyword" @change="getInvoices()">
        </div>
        <v-select v-model="ftStatus" :options="statusOpts" class="ft-type" :reduce="item => item.value"
                  :searchable="false" :placeholder="'ALL INVOICES'"></v-select>
        <v-select v-model="ftClient" :options="allClients" class="ft-client" :reduce="item => item.id"
                  label="name" :searchable="true" placeholder="ALL CLIENTS"></v-select>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th><a href="javascript:;">INVOICE NO</a></th>
          <th><a href="javascript:;">QUOTE/JOB NO</a></th>
          <th><a href="javascript:;">NAME</a></th>
          <th><a href="javascript:;">QUOTE/JOB NAME</a></th>
          <th><a href="javascript:;">STATUS</a></th>
          <th><a href="javascript:;">DATE</a></th>
          <th><a href="javascript:;">CREATED BY</a></th>
          <th width="40"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(invoice, index) in invoices" :key="index">
          <td>
            <router-link :to="{name: 'invoice', params: {invoiceId: invoice.id}}" class="black">{{ invoice.id }}</router-link>
          </td>
          <td>
            <router-link v-if="invoice.quote" :to="{ name: 'quote', params: { quoteId: invoice.quote_id } }"
                         class="black">
              {{ invoice.quote.quote_number }}
            </router-link>
            <router-link v-if="invoice.job" :to="{ name: 'job', params: { jobId: invoice.job_id } }" class="black">
              {{ (invoice.client?invoice.client.code:'') + invoice.job_id }}
            </router-link>
          </td>
          <td><router-link :to="{name: 'invoice', params: {invoiceId: invoice.id}}" class="black">{{ invoice.name }}</router-link></td>
          <td><router-link :to="{name: 'invoice', params: {invoiceId: invoice.id}}" class="black">{{ (invoice.quote ? invoice.quote.name:(invoice.job?invoice.job.name:'')) }}</router-link></td>
          <td><router-link :to="{name: 'invoice', params: {invoiceId: invoice.id}}" class="black">{{ invoice.status | statusToUCWords }}</router-link></td>
          <td><router-link :to="{name: 'invoice', params: {invoiceId: invoice.id}}" class="black">{{ invoice.invoice_date | toHumanDate('Do MMM YYYY') }}</router-link></td>
          <td><router-link :to="{name: 'invoice', params: {invoiceId: invoice.id}}" class="black">{{ invoice.creator?invoice.creator.full_name:'' }}</router-link></td>
          <td class="text-right actions">
            <a href="javascript:;" class="icon-copy" v-tooltip="'Duplicate invoice'"
               @click="confDuplicate(index)"></a>&nbsp;
            <a href="javascript:;" class="icon-trash" v-tooltip="'Delete invoice'"
               @click="confDelete(index)"></a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="hasFilters && totalItems == 0" class="alert alert-warning">
      No invoices found
    </div>

    <modal-add-invoice v-model="showModalAdd" @added="onInvoiceAdded"></modal-add-invoice>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ServiceInvoice from '@/services/invoice'
  import ModalAddInvoice from './ModalAddInvoice'
  import ModalDuplicate from './ModalDuplicate';

  export default {
    components: {
      ModalAddInvoice
    },
    data() {
      return {
        showModalAdd: false,
        keyword: '',
        activeIndex: -1,
        ftStatus: '',
        ftClient: '',
        totalItems: 0,
        invoices: []
      }
    },
    watch: {
      ftStatus: function () {
        this.getInvoices();
      },
      ftClient: function () {
        this.getInvoices();
      }
    },
    computed: {
      ...mapState({
        allClients: state => state.option.clients,
        invoiceStatuses: state => state.option.invoiceStatuses
      }),
      statusOpts() {
        let self = this, opts = [];
        for (var i in self.invoiceStatuses) {
          opts.push({label: window.stringToUCWords(self.invoiceStatuses[i]), value: self.invoiceStatuses[i]});
        }
        return opts;
      },
      hasFilters() {
        let self = this;
        return self.ftStatus != '' || self.ftClient != '' || self.keyword != '';
      },
      totalInvoiceValue() {
        let self = this, total = 0;
        for (var i in self.invoices) {
          total += parseFloat(self.invoices[i].total_value);
        }
        return total;
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showModalAdd = false;
        this.getInvoices();
      },
      confDuplicate(index) {
        let self = this;
        self.$modal.show(ModalDuplicate, {
          index: index,
          invoice: self.invoices[index]
        }, {
          clickToClose: false,
          width: 592
        });
      },
      onInvoiceAdded(invoice) {
        let self = this;
        self.$router.push({
          name: 'invoice',
          params: {
            invoiceId: invoice.id
          }
        });
      },
      confDelete(index) {
        let self = this, item = self.invoices[index];
        self.$dialog
          .confirm('Are you sure you want to delete invoice #<strong>' + item.id + '</strong>?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            ServiceInvoice.delete(item.id, function(resp){
              dialog.close();
              if (resp.status == 'FAILED') {
                self.$notify({
                  type: 'error',
                  text: resp.error,
                });
              } else {
                self.invoices.splice(index, 1);
                self.$notify({
                  type: 'success',
                  text: 'Invoice <strong>' + item.name + '</strong> has been deleted'
                });
              }
            });
          })
          .catch(() => {
          })
        ;
      },
      getInvoices() {
        let self = this,
          params = {
            ipp: 'all',
          };

        if (self.ftStatus !== '') {
          params.status = self.ftStatus;
        }
        if (self.ftClient !== '') {
          params.client_id = self.ftClient;
        }
        if (self.keyword !== '') {
          params.kw = self.keyword;
        }

        self.state = 'loading';
        ServiceInvoice.getInvoices(params, resp => {
          self.state = 'loaded';
          self.invoices = resp;
          self.totalItems = window.numkeys(self.invoices);
        });
      }
    }
  }
</script>
